<script>
    import BlogPreview from "./BlogPreview.svelte";
    import {blogs} from "./blog-store";
    import Spinner from "../../components/ui/Spinner.svelte";
</script>
<!--------------------------------------------------------------------------------------------------------------------->

{#each $blogs as article (article.id)}
    <BlogPreview {...article}/>
{:else}
    <Spinner />
{/each}

<!--------------------------------------------------------------------------------------------------------------------->
